import { PropertyChangedInformation, Notification } from '@app/shared';

@Notification({
    name: 'DepartmentUpdatedNotification'
})
export class DepartmentUpdatedNotification {
    public id: string;
    public name: string | null;
    public changes: PropertyChangedInformation[] = [];
}

@Notification({
    name: 'DepartmentCreatedNotification'
})
export class DepartmentCreatedNotification {
    public id: string;
    public name: string | null;
    public changes: PropertyChangedInformation[] = [];
}
